// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hikMK","question":"styles_question__2R-fy","description":"styles_description__3FwSs"};